import React, { useState } from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import Modal from "./Modal";
import InputLabel from "@mui/material/InputLabel";
// import { Paper } from "@mui/material";
import { API_DOMAIN_URL } from "../Common";

export function MemberInfoEditMode({
  member,
  orgUser,
  setDisplayMode,
  updateOwnedMembers,
}) {
  const SexChange = (ele) => {
    console.log(ele);
  };

  const CareLevelChange = (ele) => {
    console.log(ele);
  };

  // Validationスキーマの定義
  const validationSchema = Yup.object().shape({
    NickName: Yup.string()
      .required("表示名を入力してください")
      .max(100, "表示名は100文字以内で入力してください")
      .test("no-invalid-chars", '表示名に使用できない文字（\\ / : * ? " < > |）が含まれています', (v) =>
        v ? !/[\\/:*?"<>|]/.test(v) : true
      ),
    Furigana: Yup.string().required("ふりがなを入力してください").max(100, "ふりがなは100文字以内で入力してください").matches(/^[ぁ-ん\u3000 ー]+$/, "ふりがなはひらがなで入力してください"),
    Sex: Yup.number().required("性別を入力してください"),
    Birthday: Yup.string().required("生年月日を入力してください").test("min-age", "生年月日は3年以上前の日付を入力してください", (v) => {
      if (!v) return true;
      const date = new Date(v);
      if (isNaN(date.getTime())) return true;
      const threshold = new Date();
      threshold.setFullYear(threshold.getFullYear() - 3);
      return date <= threshold;
    }),
    BodyHeight: Yup.number().transform((cv) => (isNaN(cv) ? undefined : cv)).required("身長を入力してください").min(1, "身長は0より大きい値を入力してください"),
    BodyWeight: Yup.number().transform((cv) => (isNaN(cv) ? undefined : cv)),
    Prefecture: Yup.string().nullable().notRequired(),

    CareLevel: Yup.number().nullable().notRequired(),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    if (
      data.NickName == undefined ||
      data.Furigana == undefined ||
      data.Birthday == undefined
    ) {
      console.log("Invalid Input Value");
      return;
    }

    let editedMember = {};
    Object.assign(editedMember, member);
    editedMember.NickName = data.NickName;
    editedMember.Furigana = data.Furigana;
    editedMember.Sex = data.Sex;
    editedMember.Birthday = data.Birthday;
    editedMember.BodyHeight = data.BodyHeight;
    editedMember.BodyWeight = data.BodyWeight;
    editedMember.Prefecture = data.Prefecture;

    editedMember.CareLevel = data.CareLevel;

    updateMember(editedMember);
  };

  const updateMember = (editedMember) => {
    if (!editedMember || !editedMember.id) {
      return;
    }

    // update db
    const bodyString = JSON.stringify(editedMember);

    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL +
      `/api/UpdateMember?code=${code}&UserId=${editedMember.id}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: bodyString,
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          if (editedMember.id == orgUser.id) {
            orgUser.NickName = editedMember.NickName;
            orgUser.Furigana = editedMember.Furigana;
            orgUser.Sex = editedMember.Sex;
            orgUser.Birthday = editedMember.Birthday;
            orgUser.CareLevel = editedMember.CareLevel;
            orgUser.BodyHeight = editedMember.BodyHeight;
            orgUser.BodyWeight = editedMember.BodyWeight;
            orgUser.Prefecture = editedMember.Prefecture;

          }
          updateSuccessModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          updateErrorModalOpen();
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  const deleteMember = () => {
    if (!member || !member.id) {
      return;
    }
    if (member.CreateUserId == undefined || member.CreateUserId == "") {
      showDeleteModal("メンバー削除", "管理者は削除できません。");
      setDeleteErrorModalStatus(true);

      return;
    }

    // delete from db
    const code = process.env.REACT_APP_API_CODE;
    let url =
      API_DOMAIN_URL + `/api/DeleteMember?code=${code}&UserId=${member.id}`;
    //console.log(url);

    fetch(url, {
      method: "POST",
      body: "",
    }).then(
      function (response) {
        //console.log(response);
        if (response.status == 200) {
          deleteSuccessModalOpen();
        } else if (response.status == 204 || response.status == 400) {
          showDeleteModal("メンバー削除", "メンバー削除に失敗しました。");
        }
      },
      function (error) {
        console.log(error);
      }
    );
  };

  // 更新完了確認のモーダル
  const [updateSuccessModalStatus, setUpdateSuccessModalStatus] =
    React.useState(false);
  const updateSuccessModalOpen = () => {
    setUpdateSuccessModalStatus(true);
  };
  const updateSuccessModalClose = () => {
    setUpdateSuccessModalStatus(false);
    setDisplayMode(2); // 非活性化
    updateOwnedMembers(); // 組織内ユーザーを再取得
  };

  // エラーモーダル
  const [updateErrorModalStatus, setUpdateErrorModalStatus] =
    React.useState(false);
  const updateErrorModalOpen = () => {
    setUpdateErrorModalStatus(true);
  };
  const updateErrorModalClose = () => {
    setUpdateErrorModalStatus(false);
  };

  // 削除完了確認のモーダル
  const [deleteSuccessModalStatus, setDeleteSuccessModalStatus] =
    React.useState(false);
  const deleteSuccessModalOpen = () => {
    setDeleteSuccessModalStatus(true);
  };
  const deleteSuccessModalClose = () => {
    setDeleteSuccessModalStatus(false);
    setDisplayMode(2); // 非活性化
    updateOwnedMembers(); // 組織内ユーザーを再取得
  };

  // 削除確認モーダル
  const [deleteConfirmModalStatus, setDeleteConfirmModalStatus] =
    React.useState(false);
  const deleteConfirmModalOpen = () => setDeleteConfirmModalStatus(true);
  const deleteConfirmModalClose = () => setDeleteConfirmModalStatus(false);
  const onDeleteConfirmed = () => {
    setDeleteConfirmModalStatus(false);
    deleteMember();
  };

  // 削除エラーモーダル
  const [deleteErrorModalStatus, setDeleteErrorModalStatus] =
    React.useState(false);

  const deleteErrorModalClose = () => {
    setDeleteErrorModalStatus(false);
  };

  const [deleteErrorTitle, setDeleteErrorTitle] = useState("");
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");

  const showDeleteModal = (title, message) => {
    setDeleteErrorTitle(title);
    setDeleteErrorMessage(message);

    setDeleteErrorModalStatus(true);
  };

  //console.log(member);
  return (
    <>
      <Typography component="h1" variant="h5" sx={{ mt: 3 }}>
        メンバー編集
      </Typography>
      <Box
        component="form"
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        sx={{ mt: 5, p: 3, border: "1px solid grey" }}
      >
        <Typography variant="h6" align="center">
          メンバー情報
        </Typography>
        <Grid md={{ flexGrow: 1 }} container spacing="2">
          <Grid item md={12}>
            <Grid container justifyContent="center" spacing={1}>
              <Grid item md={12}>
                <TextField
                  name="NickName"
                  fullWidth
                  required
                  size="small"
                  id="NickName"
                  label="表示名"
                  defaultValue={member.NickName}
                  {...register("NickName")}
                  error={errors.NickName ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.NickName?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="center"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={12}>
                <TextField
                  name="Furigana"
                  required
                  fullWidth
                  size="small"
                  id="Furigana"
                  label="ふりがな"
                  defaultValue={member.Furigana}
                  {...register("Furigana")}
                  error={errors.Furigana ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Furigana?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              sx={{ mt: "1px" }}
              spacing={1}
            >
              <Grid item md={2}>
                <InputLabel id="demo-simple-select-autowidth-label" required>
                  <Typography variant="caption">性別</Typography>
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="Sex"
                  defaultValue={member.Sex}
                  width="50"
                  size="small"
                  label="性別"
                  onChange={(ele) => SexChange(ele)}
                  {...register("Sex")}
                  error={errors.Sex ? true : false}
                >
                  <MenuItem value={1}>男</MenuItem>
                  <MenuItem value={2}>女</MenuItem>
                </Select>
                <Typography variant="inherit" color="textSecondary">
                  {errors.Sex?.message}
                </Typography>
              </Grid>
              <Grid item md={4} sx={{ mt: 3 }}>
                <TextField
                  name="Birthday"
                  required
                  size="small"
                  id="Birthday"
                  label="生年月日 例)1960/01/01"
                  defaultValue={member.Birthday.slice(0, 10)}
                  {...register("Birthday")}
                  error={errors.Birthday ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Birthday?.message}
                </Typography>
              </Grid>
              <Grid item md={6}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  <Typography variant="caption">介護レベル</Typography>
                </InputLabel>
                <Select
                  labelId="care-level-label"
                  id="CareLevel"
                  defaultValue={member.CareLevel ?? 0}
                  width="60"
                  label="介護度"
                  size="small"
                  onChange={(ele) => CareLevelChange(ele)}
                  {...register("CareLevel")}
                  error={errors.CareLevel ? true : false}
                >
                  <MenuItem value={0}>&nbsp;</MenuItem>
                  <MenuItem value={1}>要支援１</MenuItem>
                  <MenuItem value={2}>要支援２</MenuItem>
                  <MenuItem value={3}>要介護１</MenuItem>
                  <MenuItem value={4}>要介護２</MenuItem>
                  <MenuItem value={5}>要介護３</MenuItem>
                  <MenuItem value={6}>要介護４</MenuItem>
                  <MenuItem value={7}>要介護５</MenuItem>
                </Select>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={6}>
                <TextField
                  name="BodyHeight"
                  required
                  size="small"
                  id="BodyHeight"
                  label="身長(cm)"
                  defaultValue={member.BodyHeight}
                  {...register("BodyHeight")}
                  error={errors.BodyHeight ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.BodyHeight?.message}
                </Typography>
                <Typography variant="caption" color="textSecondary">
                  身長は測定値の計算に使用するため必須となります。
                </Typography>
              </Grid>
              <Grid item md={6}>
                <TextField
                  name="BodyWeight"
                  size="small"
                  id="BodyWeight"
                  label="体重(kg)"
                  defaultValue={member.BodyWeight}
                  {...register("BodyWeight")}
                  error={errors.BodyWeight ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.BodyWeight?.message}
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              justifyContent="left"
              sx={{ mt: "3px" }}
              spacing={1}
            >
              <Grid item md={6}>
                <TextField
                  name="Prefecture"
                  size="small"
                  id="Prefecture"
                  label="都道府県"
                  defaultValue={member.Prefecture}
                  {...register("Prefecture")}
                  error={errors.Prefecture ? true : false}
                />
                <Typography variant="inherit" color="textSecondary">
                  {errors.Prefecture?.message}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={8} container justifyContent="right">
          <Button
            variant="contained"
            color="success"
            sx={{ mt: 2, width: 100 }}
            type="submit"
            onClick={handleSubmit(onSubmit)}
          >
            更新
          </Button>
        </Grid>
        <Grid item xs={2} container justifyContent="center">
          <Button
            variant="contained"
            color="error"
            sx={{ mt: 2, width: 100 }}
            onClick={deleteConfirmModalOpen}
          >
            削除
          </Button>
        </Grid>
      </Grid>
      <Modal
        title={"メンバー削除"}
        message={`「${member.NickName}」を削除しますか？この操作は元に戻せません。`}
        status={deleteConfirmModalStatus}
        okBtnLabel={"削除"}
        okBtnCallback={onDeleteConfirmed}
        cancelBtnCallback={deleteConfirmModalClose}
      />
      <Modal
        title={"更新失敗"}
        message={"メンバーの更新に失敗しました"}
        status={updateErrorModalStatus}
        okBtnCallback={updateErrorModalClose}
      />
      <Modal
        title={"更新成功"}
        message={"メンバーの更新が完了しました"}
        status={updateSuccessModalStatus}
        okBtnCallback={updateSuccessModalClose}
      />
      <Modal
        title={deleteErrorTitle}
        message={deleteErrorMessage}
        status={deleteErrorModalStatus}
        okBtnCallback={deleteErrorModalClose}
      />
      <Modal
        title={"削除成功"}
        message={"メンバーの削除が完了しました"}
        status={deleteSuccessModalStatus}
        okBtnCallback={deleteSuccessModalClose}
      />
    </>
  );
}

MemberInfoEditMode.propTypes = {
  member: PropTypes.object,
  orgUser: PropTypes.object,
  setDisplayMode: PropTypes.any,
  updateOwnedMembers: PropTypes.any,
};
